export const sortingActivityDefaultContent = {
    en: {
        sortingActivityTexts: {
            1: {
                cardTitle: 'Example card',
                sectionTitle: 'Example category'
            },
            2: {
                cardTitle: 'Another example card',
                sectionTitle: 'Another example category'
            },
        }
    },
    es: {
        sortingActivityTexts: {
            1: {
                cardTitle: 'Tarjeta de ejemplo',
                sectionTitle: 'Categoría de ejemplo'
            },
            2: {
                cardTitle: 'Otra tarjeta de ejemplo',
                sectionTitle: 'Otra categoría de ejemplo'
            },
        }
    }
}
